import React, { useState, useEffect } from 'react';
import { Calendar, MessageCircle, Menu, X } from 'lucide-react';
import { Button } from './ui/button';
import { NAV_LINKS } from '../mock/mock';
import Logo from './Logo';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState('#home');

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-white/85 backdrop-blur-xl border-b border-purple-100/70 shadow-[0_8px_30px_-15px_rgba(95,37,159,0.2)]'
          : 'bg-white/60 backdrop-blur-md'
      }`}
    >
      <div className="max-w-[1440px] mx-auto px-5 lg:px-10">
        <div className="flex items-center justify-between h-[76px]">
          <Logo />

          <nav className="hidden xl:flex items-center gap-1">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setActive(l.href)}
                className={`relative px-3 py-2 text-[14px] font-medium whitespace-nowrap transition-colors ${
                  active === l.href ? 'text-[#5F259F]' : 'text-slate-700 hover:text-[#5F259F]'
                }`}
              >
                {l.label}
                {active === l.href && (
                  <span className="absolute left-3 right-3 -bottom-0.5 h-[2px] rounded-full gradient-primary" />
                )}
              </a>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-3">
            <Button className="gradient-primary text-white rounded-full px-5 h-11 font-semibold btn-glow border-0">
              <Calendar className="w-4 h-4 mr-2" />
              Request Free Demo
            </Button>
            <Button variant="outline" className="rounded-full h-11 px-5 font-semibold border-2 border-emerald-500 text-emerald-600 hover:bg-emerald-50">
              <MessageCircle className="w-4 h-4 mr-2" />
              Chat on WhatsApp
            </Button>
          </div>

          <button onClick={() => setOpen(!open)} className="lg:hidden p-2 rounded-xl bg-purple-50 text-[#5F259F]">
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="xl:hidden bg-white/95 backdrop-blur-xl border-t border-purple-100 px-5 py-5">
          <div className="flex flex-col gap-1 max-w-[1440px] mx-auto">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="px-3 py-2.5 rounded-xl text-slate-700 font-medium hover:bg-purple-50 hover:text-[#5F259F]"
              >
                {l.label}
              </a>
            ))}
            <div className="flex gap-2 mt-3">
              <Button className="gradient-primary text-white rounded-full h-11 flex-1 font-semibold border-0">Request Demo</Button>
              <Button variant="outline" className="rounded-full h-11 flex-1 border-2 border-emerald-500 text-emerald-600 font-semibold">WhatsApp</Button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
